(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.ConfirmationRow = (function(superClass) {
    var headerSort;

    extend(ConfirmationRow, superClass);

    function ConfirmationRow(scope, transitions, state, generate, data1, loader, window, modal) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.generate = generate;
      this.data = data1;
      this.loader = loader;
      this.window = window;
      this.modal = modal;
      this.paginate = bind(this.paginate, this);
      this.groupProducts = bind(this.groupProducts, this);
      this.launchAddProduct = bind(this.launchAddProduct, this);
      this.confirm = bind(this.confirm, this);
      this.clearProductSelection = bind(this.clearProductSelection, this);
      this.clearCompanySelections = bind(this.clearCompanySelections, this);
      this.getProductsBySeedCompany = bind(this.getProductsBySeedCompany, this);
      this.getSeedCompaniesByCrop = bind(this.getSeedCompaniesByCrop, this);
      this.updateChildrenProduct = bind(this.updateChildrenProduct, this);
      this.updateChildrenSeedCompanies = bind(this.updateChildrenSeedCompanies, this);
      this.updateChildrenNumberOfProducts = bind(this.updateChildrenNumberOfProducts, this);
      this.updateChildrenCrop = bind(this.updateChildrenCrop, this);
      this.updateChildrenYear = bind(this.updateChildrenYear, this);
      this.updateTab = bind(this.updateTab, this);
      this.confirmationStatusUpdate = bind(this.confirmationStatusUpdate, this);
      this.changeHeaderIcon = bind(this.changeHeaderIcon, this);
      this.clickableHeaderSort = bind(this.clickableHeaderSort, this);
      this.determineStatus = bind(this.determineStatus, this);
      this.conversionRequestSent = bind(this.conversionRequestSent, this);
      ConfirmationRow.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.sorting = {
        classes: {
          "default": 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc'
        },
        columns: {
          year: false,
          status: false,
          farmName: true
        },
        active: 'fa-sort-desc'
      };
      this.scope.sortColumn = 'farmName';
      this.scope.resize = 0;
      this.scope.resizeTable = (function(_this) {
        return function() {
          return _this.scope.resize++;
        };
      })(this);
      this.scope.clickableHeaderSort = this.clickableHeaderSort;
      this.window.confirmationStatusUpdate = this.confirmationStatusUpdate;
      this.window.conversionRequestSent = this.conversionRequestSent;
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          _this.window.confirmationStatusUpdate = null;
          return _this.window.conversionRequestSent = null;
        };
      })(this));
    }

    ConfirmationRow.prototype.conversionRequestSent = function(data) {
      return this.scope.$emit('uploads:processing');
    };

    ConfirmationRow.prototype.determineStatus = function(parent) {
      return this.generate.determineStatus(parent).then((function(_this) {
        return function(response) {
          parent.data.status = response.data.data;
          return _this.updateTab();
        };
      })(this));
    };

    headerSort = function(column, a, b) {
      var col, index, multisort, result;
      result = strnatcasecmp(a[column], b[column]);
      multisort = {
        0: 'farmName',
        1: 'year',
        2: 'status'
      };
      if (result === 0) {
        for (index in multisort) {
          col = multisort[index];
          if (col !== column) {
            result = strnatcasecmp(a[col], b[col]);
            if (result !== 0) {
              return result;
            }
          }
        }
      }
      return result;
    };

    ConfirmationRow.prototype.clickableHeaderSort = function(column) {
      if (this.scope.sortColumn !== column) {
        this.changeHeaderIcon(column);
        this.scope.sorting.active = this.scope.sorting.classes.down;
        this.scope.sortColumn = column;
        return this.scope.parents.sort(headerSort.bind(null, column));
      } else {
        this.scope.parents.reverse();
        return this.changeHeaderIcon(column);
      }
    };

    ConfirmationRow.prototype.changeHeaderIcon = function(column) {
      var cname, ref, results, v;
      if (this.scope.sorting.active === this.scope.sorting.classes.down) {
        this.scope.sorting.active = this.scope.sorting.classes.up;
      } else {
        this.scope.sorting.active = this.scope.sorting.classes.down;
      }
      this.scope.sorting.columns[column] = true;
      ref = this.scope.sorting.columns;
      results = [];
      for (cname in ref) {
        v = ref[cname];
        if (cname !== column) {
          results.push(this.scope.sorting.columns[cname] = false);
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    ConfirmationRow.prototype.confirmationStatusUpdate = function(data) {
      var i, len, parent, ref;
      if (this.scope.parents != null) {
        ref = this.scope.parents;
        for (i = 0, len = ref.length; i < len; i++) {
          parent = ref[i];
          if (!(parent.parent_id === data.parents_id)) {
            continue;
          }
          parent.data.status = data.success ? 'Done' : 'Failed';
          parent.loading = false;
        }
        return this.scope.$apply();
      }
    };

    ConfirmationRow.prototype.updateTab = function() {
      var confirmed, i, len, parent, ref, ref1;
      confirmed = 0;
      ref = this.scope.parents;
      for (i = 0, len = ref.length; i < len; i++) {
        parent = ref[i];
        if ((ref1 = parent.data.status) === 'Done' || ref1 === 'Processing') {
          confirmed += 1;
        }
      }
      return this.scope.tabs[this.scope.tab].unconfirmed = this.scope.parents.length - confirmed;
    };

    ConfirmationRow.prototype.updateChildrenYear = function(parent) {
      return this.generate.updateYears(parent.parent_id, parent.data.selected.year).then((function(_this) {
        return function() {
          parent.loading = true;
          return _this.checkSelectionsForConfirm(parent).then(function() {
            return parent.loading = false;
          });
        };
      })(this));
    };

    ConfirmationRow.prototype.updateChildrenCrop = function(parent, crop, relationshipId) {
      return this.generate.updateChildrenCrop(parent.parent_id, crop.id, relationshipId).then((function(_this) {
        return function() {
          parent.loading = true;
          return _this.checkSelectionsForConfirm(parent).then(function() {
            return parent.loading = false;
          });
        };
      })(this));
    };

    ConfirmationRow.prototype.updateChildrenNumberOfProducts = function(parent, numberOfProducts, relationshipId) {
      return this.generate.updateChildrenNumberOfProducts(parent.parent_id, numberOfProducts, relationshipId).then((function(_this) {
        return function() {
          parent.loading = true;
          return _this.checkSelectionsForConfirm(parent).then(function() {
            return parent.loading = false;
          });
        };
      })(this));
    };

    ConfirmationRow.prototype.updateChildrenSeedCompanies = function(parent, product) {
      var ref, ref1;
      if ((product != null ? (ref = product.selected) != null ? (ref1 = ref.seedCompany) != null ? ref1.id : void 0 : void 0 : void 0) && product.id) {
        return this.generate.updateChildrenSeedCompanies(product.selected.seedCompany.id, product.id).then((function(_this) {
          return function() {
            product.selected.product = null;
            parent.loading = true;
            return _this.checkSelectionsForConfirm(parent).then(function() {
              return parent.loading = false;
            });
          };
        })(this));
      }
    };

    ConfirmationRow.prototype.updateChildrenProduct = function(product, parent) {
      return this.generate.updateChildrenProduct(product.selected.product, product.id).then((function(_this) {
        return function() {
          parent.loading = true;
          return _this.checkSelectionsForConfirm(parent).then(function() {
            return parent.loading = false;
          });
        };
      })(this));
    };

    ConfirmationRow.prototype.getSeedCompaniesByCrop = function(product, crop, reset) {
      if (reset == null) {
        reset = true;
      }
      if (reset) {
        product.selected.seedCompany = null;
        product.selected.product = null;
      }
      return this.generate.getSeedCompaniesByCrop(crop.id).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return product.required.seedCompanies = response.data.data;
          }
        };
      })(this));
    };

    ConfirmationRow.prototype.getProductsBySeedCompany = function(product, reset) {
      if (reset == null) {
        reset = true;
      }
      return this.generate.getProductsBySeedCompany(product.selected.crop.id, product.selected.seedCompany.id).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            if (reset) {
              product.selected.product = null;
            }
            return product.required.products = response.data.data;
          }
        };
      })(this));
    };

    ConfirmationRow.prototype.clearCompanySelections = function(product) {
      product.selected.seedCompany = null;
      return this.clearProductSelection(product);
    };

    ConfirmationRow.prototype.clearProductSelection = function(product) {
      return product.selected.product = null;
    };

    ConfirmationRow.prototype.confirm = function(parent) {
      parent.data.status = 'Processing';
      parent.loading = true;
      parent.disabled.confirm = true;
      return this.generate.confirm(parent.parent_id).then((function(_this) {
        return function(response) {
          return _this.updateTab();
        };
      })(this));
    };

    ConfirmationRow.prototype.launchAddProduct = function(row, parent) {
      var cropId;
      cropId = row.selected.crop.id;
      return this.modal.open({
        windowClass: 'smaller_dialog',
        templateUrl: 'backend/grower/products/create',
        controller: 'Planting.Controllers.AddGrowerProductController',
        resolve: {
          seedCompany: function() {
            return row.selected.seedCompany;
          },
          autoSelect: function() {
            return {
              crop: cropId
            };
          }
        }
      }).result.then((function(_this) {
        return function(product) {
          row.selected.product = product;
          row.selected.product.isGrower = true;
          _this.scope.getProductsBySeedCompany(row, false);
          return _this.scope.updateChildrenProduct(row, parent);
        };
      })(this));
    };

    ConfirmationRow.prototype.groupProducts = function(product) {
      if (product.isGrower) {
        return 'Your Custom';
      } else {
        return void 0;
      }
    };

    ConfirmationRow.prototype.paginate = function(table_state, cnt) {
      this.cnt = cnt;
      if (this.reload) {
        this.reload = false;
        table_state.pagination.start = 0;
        table_state.pagination.number = 25;
      }
      return this.loadParentData(table_state.pagination.start || 0, table_state.pagination.number || 25).then((function(_this) {
        return function(result) {
          table_state.pagination.totalItemCount = result;
          return table_state.pagination.numberOfPages = Math.ceil(result / table_state.pagination.number);
        };
      })(this))["catch"]((function(_this) {
        return function(err) {
          return _this.setAlert({
            msg: 'Error loading data',
            type: 'error'
          });
        };
      })(this))["finally"]((function(_this) {
        return function() {
          _this.scope.resize++;
          _this.loader.hideAll();
          return true;
        };
      })(this));
    };

    return ConfirmationRow;

  })(Controller);

}).call(this);
